// Ejemplos con la pantalla TFT.
import { part, wires, UNO } from './helpers.js';

export const EXAMPLES = [
  {
    id: 'tft-graficos',
    category: 'Pantallas',
    name: 'TFT a color: gráficos y texto',
    description: 'La pantalla ILI9341 de 2.8″ dibuja texto, figuras y un contador con Adafruit_GFX.',
    project: {
      name: 'TFT ILI9341',
      files: {
        'sketch.ino': `// Pantalla TFT ILI9341 de 2.8 pulgadas por SPI (librerías Adafruit_ILI9341 y Adafruit_GFX).
#include <SPI.h>
#include <Adafruit_GFX.h>
#include <Adafruit_ILI9341.h>

Adafruit_ILI9341 tft(10, 9, 8);   // CS, DC, RESET

void setup() {
  tft.begin();
  tft.setRotation(1);              // horizontal: 320 x 240
  tft.fillScreen(ILI9341_NAVY);
  tft.fillRoundRect(10, 10, 300, 50, 10, ILI9341_WHITE);
  tft.setTextColor(ILI9341_NAVY);
  tft.setTextSize(3);
  tft.setCursor(30, 23);
  tft.print("Arduino 3D");
  for (int i = 0; i < 6; i++) {
    tft.fillCircle(40 + i * 48, 110, 18, tft.color565(255 - i * 40, 40 + i * 40, 120));
  }
  tft.drawRect(10, 150, 300, 80, ILI9341_YELLOW);
  tft.setTextColor(ILI9341_YELLOW, ILI9341_NAVY);
  tft.setTextSize(2);
  tft.setCursor(24, 162);
  tft.print("Segundos:");
}

void loop() {
  tft.setCursor(24, 192);
  tft.setTextSize(3);
  tft.print(millis() / 1000);
  tft.print("   ");
  delay(200);
}
`,
      },
      parts: [UNO, part('tft1', 'tft-ili9341', {}, { x: 0, z: -82, rot: 0 })],
      wires: wires([
        ['tft1:VCC', 'uno:5V', 'red'],
        ['tft1:GND', 'uno:GND.1', 'black'],
        ['tft1:CS', 'uno:10', 'orange'],
        ['tft1:RST', 'uno:8', 'white'],
        ['tft1:DC', 'uno:9', 'purple'],
        ['tft1:MOSI', 'uno:11', 'blue'],
        ['tft1:SCK', 'uno:13', 'yellow'],
        ['tft1:LED', 'uno:IOREF', 'red'],
        ['tft1:MISO', 'uno:12', 'green'],
      ]),
    },
  },
];
